<div class="container-fluid">
    <div class="container-xxxl disease-page-top-element-padding">
        <div class="d-flex row pt-5">
            <div class="col-12 col-lg-6 left-side align-items-center">
                <div class="container-fluid pb-32">
                    <div class="row">
                        <h2 class="section-heading text-blue border-blue">Find Your Community</h2>
                    </div>
                </div>
                <div *ngIf="article.displayTitle" class="title">{{ article.title }}</div>
                <p [innerHtml]="article.bodyText"></p>
            </div>

            <div class="d-none d-lg-flex d-print-none col-lg-6 right-side">
                <img class="mb-3 rounded-3" [src]="imgsrc" [alt]="imgAltText" />
            </div>
            <div class="col-12 d-flex d-lg-none d-print-none mobile-img">
                <img class="mb-3 rounded-3" [src]="imgsrc" [alt]="imgAltText" />
            </div>
        </div>
    </div>
</div>

<div class="white-chevron d-print-none"></div>
